interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
  tone?: "default" | "light";
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "center",
  tone = "default",
}: SectionHeadingProps) {
  const alignCls = align === "center" ? "items-center text-center" : "items-start text-left";
  const titleCls = tone === "light" ? "text-background-50" : "text-foreground-950";
  const descCls = tone === "light" ? "text-background-200" : "text-foreground-600";
  const eyebrowCls = tone === "light" ? "bg-background-50/15 text-background-100" : "bg-primary-100 text-primary-700";

  return (
    <div className={`flex flex-col gap-3 md:gap-4 ${alignCls}`}>
      <span
        className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-medium tracking-wide ${eyebrowCls}`}
      >
        <i className="ri-sparkling-2-fill text-[13px]"></i>
        {eyebrow}
      </span>
      <h2
        className={`font-heading text-2xl md:text-4xl font-bold leading-snug ${titleCls}`}
      >
        {title}
      </h2>
      {desc ? (
        <p className={`max-w-2xl text-sm md:text-base leading-relaxed ${descCls}`}>{desc}</p>
      ) : null}
    </div>
  );
}